
define('ldsh!modules/lp_integration/templates/webservice_fields_step', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h1 class="ed-section-title">' +
((__t = ( step? 'Step ' + step : 'Init' )) == null ? '' : __t) +
'</h1>\n';
 _.each(fields, function(nameAttr){ ;
__p += '\n<div class="ed-form-group ed-form-group-inline js-fieldmapping ed-user-item" data-field="' +
((__t = (nameAttr)) == null ? '' : __t) +
'">\n  <label>' +
((__t = ( nameAttr )) == null ? '' : __t) +
'</label>\n  <div>\n    <input type="text" class="ed-form-control ed-form-item-full js-postfield" value="' +
((__t = ( dataFields[nameAttr] )) == null ? '' : __t) +
'" />\n  </div>\n</div>\n';
 }) ;
__p += '\n';

}
return __p
};});

